import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {CdkDragDrop,moveItemInArray,transferArrayItem,} from "@angular/cdk/drag-drop";
import { IColumns } from 'bi-interfaces';
import { IDialog } from 'bi-interfaces';
import { UiProfileService } from '../../services/ui-profile.service';
import { ValidatorFn, Validators } from '@angular/forms';



@Component({
  selector: 'bi-grid-column-customizer',
  standalone: false,
  templateUrl: './bi-column-customizer.component.html',
  styleUrl: './bi-column-customizer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BIGridColumnCustomizerComponent implements OnInit, IDialog {
  data: any;
  outputValue: any;
  
  tempColumns!: IColumns[];

  constructor(private uiProfileService: UiProfileService){
  }

  ngOnInit(): void {
    this.tempColumns = this.data.columns.filter((col: IColumns) => ((col.IsVisible == true || col.IsHiddenByUser == true) &&  !this.isRequiredColumn(col.Validators))).map((col: IColumns) => ({...col}));
  }

  drop(event: CdkDragDrop<IColumns[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  OnItemVisibilityChanges(column: IColumns, event: Event){
    const isChecked = (event.target as HTMLInputElement).checked;
    column.IsVisible = isChecked;
    column.IsHiddenByUser = !isChecked;
    let test = 0;
  }

  NotifyParent(){
    const columnsNotEdited = this.data.columns.filter((originalCol: IColumns) => !this.tempColumns.some(tempCol => tempCol.Name == originalCol.Name));
    this.data.columns = [...this.tempColumns, ...columnsNotEdited]
    this.data.component.Columns = this.data.columns;
  }
  OnOk(){
    this.NotifyParent();
  };
  OnCancel(onclose: boolean){
    this.OnSetAsDefault();
  };

  OnSetAsDefault(){
    this.NotifyParent()
    this.uiProfileService.emitSaveColumnsConfig(this.data.component.DomID, this.tempColumns)
  }

  isRequiredColumn(itemValidators: ValidatorFn | Array<ValidatorFn> | undefined | null){
    if(!itemValidators)
      return false;
    if(Array.isArray(itemValidators))
      return itemValidators.includes(Validators.required);
    return itemValidators == Validators.required;
  }
}
